
        // Auto-generated file - do not edit manually

        // Generated by crm-system-generator-plugin

        // Found 3 CRM systems


        // ===== SYSTEM CONSTANTS =====


        // /** All available CRM system IDs */

        export const CRM_SYSTEMS_IDS = ['collaborate', 'airtable', 'salesforce'] as const;


        export const DEFAULT_CRM_SYSTEM = 'collaborate' as const;


        // ===== SYSTEM-SPECIFIC CONSTANTS =====

        // 
/** Field types for Collaborate CRM system */
export const COLLABORATE_FIELD_TYPES = ['text', 'textarea', 'number', 'currency', 'slider', 'checkbox', 'radio', 'picklist', 'picklist_multiple', 'boolean', 'rank', 'date'] as const;
            

/** Field types for Airtable CRM system */
export const AIRTABLE_FIELD_TYPES = ['singleLineText', 'multilineText', 'number', 'currency', 'percent', 'rating', 'singleSelect', 'multipleSelects', 'checkbox', 'date', 'duration_hours', 'duration_days', 'dateTimezone', 'email', 'phoneNumber', 'url'] as const;
            

/** Field types for Salesforce CRM system */
export const SALESFORCE_FIELD_TYPES = ['text', 'textarea', 'number', 'currency', 'slider', 'radio', 'checkbox', 'picklist', 'picklist_multiple', 'boolean', 'date'] as const;
            
